const filterCriteria = criteria =>
  criteria.filter(criteria => criteria.criterion)

export { filterCriteria }
